import { render, staticRenderFns } from "./CommissionsPaid.vue?vue&type=template&id=8f645f6c"
import script from "./CommissionsPaid.vue?vue&type=script&lang=js"
export * from "./CommissionsPaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports